export default function validate(values) {
  const errors = {};
  if (!values.hostIP) {
    errors.hostIP = 'Please enter host IP';
  }
  if (!values.description) {
    errors.description = 'Please enter description';
  }
  return errors;
}
